import React from 'react'
import PropTypes from 'prop-types'
import {Button, ButtonGroup} from 'reactstrap'
import {API_BASE_URL} from '../../utils/apiConfig'
import {getUserPermissions} from '../../utils/userPermissions'
import {CompanyRoles} from './roles'

const propTypes = {
  formToggleFunction: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  company: PropTypes.object.isRequired,
  fomIsOpen: PropTypes.bool.isRequired
}

const CompanyRow = ({company, history, formToggleFunction, fomIsOpen}) => {
  return (
    <tr key={company.id} className="tr-render-list" onClick={() => history.push(`/companies/${company.id}`)}>
      <td>{company.logo && <img alt='logo' src={API_BASE_URL + company.logo.thumb_url}/>}</td>
      <td><b>{company.name}</b></td>
      <td><b>{(company.roles || []).map(slug => CompanyRoles.find(o => o.slug === slug).name).join(', ')}</b></td>
      <td>{company.city}</td>
      <td>{company.nip}</td>
      <td>{company.phone}</td>
      <td>{company.email}</td>
      <td>
        <ButtonGroup size='sm' className="float-right">
          {!fomIsOpen && getUserPermissions('core.companies.update') &&
          <Button color="warning" title="Edit" onClick={(e) => {
            e.stopPropagation()
            formToggleFunction({data: company})
          }}>
            <i className="fa fa-edit"/>
          </Button>}
        </ButtonGroup>
      </td>
    </tr>
  )
}

CompanyRow.propTypes = propTypes

export default CompanyRow



// WEBPACK FOOTER //
// ./src/components/Companies/CompanyRow.js